/*
 *   File : pause-reward.js
 *   Author : https://evoqins.com
 *   Description : Pause reward modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useState } from 'react';

// Custom component 
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { APIService } from '../../Service';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const PauseRewardModal = (props) => {

    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);

    const [loader, setLoader] = useState(false);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("pause-reward-modal-close");
        button.click();
        props.handleClose();
    };

    const _handleSubmit = () => {
        _pauseReward();
    };

    // API - POST pause reward
    const _pauseReward = () => {
        let is_post = false;
        let url = 'CA/sales-specialist/toggle-pause-rewards';
        let data = {};
        setLoader(true);
        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                props.handleSuccess();
                _handleCloseModal();

                toast.dismiss();
                toast.success(response.data.reward_enabled === true ? "Successfully resumed the rewards" : "Successfully paused the rewards", {
                    type: "success",
                    className: "e-toast",
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoader(false);
        });
    };

    return (
        <div className="modal fade" id="pause-reward-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="approveRequestModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered e-border-radius-8 e-pause-modal-wrapper">
                <div className="modal-content e-border-radius-8">
                    <div className="modal-header px-4 pt-4 pb-2 border-0 align-items-start justify-content-between">
                        <h6 className='mb-2 e-primary-font-playfair e-font-18 e-text-raisin-black e-font-weight-500 line-height-28px'>
                            {props.title}
                        </h6>
                        <img src={require("../../Assets/Image/CountryAdmin/close-icon.svg").default}
                            draggable={false}
                            className='cursor-pointer'
                            alt='close'
                            onClick={_handleCloseModal} />
                        <button type="button" id='pause-reward-modal-close' className="btn-close shadow-none d-none" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body px-4 pb-4 pt-0">

                        <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                            {props.description}
                        </p>
                        <div className='pt-4 mt-1'>
                            <div className='row g-3'>
                                <div className='col-6'>
                                    <SecondaryButton name="Cancel"
                                        className="w-100"
                                        onPress={_handleCloseModal} />
                                </div>
                                <div className='col-6'>
                                    <PrimaryButton name={props.primaryButtonLabel}
                                        className="w-100"
                                        status={loader}
                                        onPress={_handleSubmit} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(PauseRewardModal);